import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";

import { formatDistance } from "date-fns";
import { ptBR } from "date-fns/locale";

import YouTube from "react-youtube";
import Carousel from "react-bootstrap/Carousel";

import { i18n } from '../../translate/i18n';

import "./style.css";
import format from "utils/dateFormat";

export default function Feed({ listFeed }) {
  //typeFile
  // 1 - Image
  // 2 - Video
  // 3 - Youtube

  return (
    <>
      {listFeed ? (
        <>
          <div className="container-item-feed-social" key={listFeed}>
            <div className="area-text-feed-social">
              <p className="data-item-publicacoes">
                {formatDistance(new Date(), new Date(listFeed.createdAt), {
                  includeSeconds: true,
                  locale: ptBR,
                })}
              </p>
              <div className="area-title-data-publicacoes">
                <p className="title-item-publicacoes">{listFeed.Title}</p>
              </div>
              {listFeed.SubTitle ? (
                <p className="subtitle-item-publicacoes">{listFeed.SubTitle}</p>
              ) : (
                <></>
              )}
              <div className="descricao-feed-item-publicacoes">
                {listFeed.Description}
              </div>
            </div>
            <div className="area-item-publicacoes">
              {listFeed.FeedFiles.length > 0 ? (
                <>
                  {listFeed.TypeFile === 1 ? (
                    <Carousel controls={false}>
                      {listFeed.FeedFiles.map((item, index) => (
                        <Carousel.Item key={index}>
                          <img
                            className="image-post-publicacoes-feed"
                            src={item.File}
                            alt="img"
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  ) : (
                    <>
                      {listFeed.TypeFile === 2 ? (
                        <video
                          className="image-post-publicacoes-feed"
                          src={listFeed.FeedFiles[0].File}
                          controls
                        />
                      ) : (
                        <YouTube videoId={listFeed.youtube} />
                      )}
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="area-like-publicacoes">
              {Number(listFeed.TypeFeed) === 3 ? (
                <div className="text-event-publicacoes-item">
                  {`${format(
                    listFeed.dateTimeEvent,
                    "dd/MM/yyyy HH:mm"
                  )} - Participar`}
                </div>
              ) : (
                <a
                  className="text-link-publicacoes-item"
                  href={listFeed.Link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {listFeed.TextLink}
                </a>
              )}

              <div className="box-right-like-publicacoes">
                <div>
                  <FontAwesomeIcon
                    color="gray"
                    icon={faThumbsUp}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <p className="qntd-like-item-publicacoes">{5}</p>
              </div>
            </div>
          </div>
        </>
      ) : (
        <p className="text-item-nenhuma-publicacao-feed">
          {i18n.t('publications')}
        </p>
      )}
    </>
  );
}
